import { render, staticRenderFns } from "./ViewReceivedBy.vue?vue&type=template&id=a6f9449c&scoped=true"
import script from "./ViewReceivedBy.vue?vue&type=script&lang=js"
export * from "./ViewReceivedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f9449c",
  null
  
)

export default component.exports